import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import setupAutoUpdates from './autoUpdateWorker';

// Initialize the automatic service worker updates
setupAutoUpdates();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
        <App />
    // </React.StrictMode>
);
